export const initialValues = {
  sectionName: '',
  sectionIcon: '',
  standarts: '',
  notes: '',
  selectedSections: [],
  filteredSectionName: '',
};
